module.exports = __webpack_public_path__ + "img/img4.da4d13fa.jpg";